export default "__VITE_ASSET__5cf02c45__"